import { render } from "./Edit.vue?vue&type=template&id=76f78533"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Packages/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76f78533"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76f78533', __exports__)) {
    console.log('reload')
    api.reload('76f78533', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=76f78533", () => {
    console.log('re-render')
    api.rerender('76f78533', render)
  })

}


export default __exports__